module.exports = __webpack_public_path__ + "static/img/erweima.e77c781.png";


//////////////////
// WEBPACK FOOTER
// ./static/Upload/erweima.png
// module id = Umoo
// module chunks = 35